// ABOUTME: Returns a React key that changes when a text editor's value is replaced from outside.
// ABOUTME: Lets editors that only read their initial value pick up programmatic changes.
import {useCallback, useEffect, useRef, useState} from 'react'

export const useEditorKeyOnExternalChange = (
  value: string | null | undefined
): {editorKey: number; markEditorValue: (typedValue: string) => void} => {
  const lastEditorValue = useRef(value ?? '')
  const [editorKey, setEditorKey] = useState(0)

  useEffect(() => {
    const currentValue = value ?? ''
    if (currentValue === lastEditorValue.current) return
    lastEditorValue.current = currentValue
    setEditorKey((key) => key + 1)
  }, [value])

  const markEditorValue = useCallback((typedValue: string) => {
    lastEditorValue.current = typedValue
  }, [])

  return {editorKey, markEditorValue}
}
